export default "__VITE_ASSET__YdHYmwVy__"